// The video editor's layers strings (components/Editor), under t('editor.rve.layers.<key>').
// Same keys in en, es, pt and ar; Arabic follows ../../ARABIC_STYLE.md.
export default {
  common: {
    volume: "Volumen",
    mute: "Silenciar",
    unmute: "Activar sonido",
  },
  tabs: {
    settings: "Ajustes",
    style: "Estilo",
    allCount: "Todo ({n})",
  },
  style: {
    appearance: "Apariencia",
    fit: "Ajuste",
    fitCover: "Cubrir",
    fitContain: "Contener",
    fitFill: "Rellenar",
    borderRadius: "Radio del borde",
    brightness: "Brillo",
    padding: "Relleno",
    paddingBackground: "Fondo del relleno",
    clear: "Borrar",
  },
  filter: {
    preset: "Filtro predefinido",
    custom: "Personalizado",
    presetPreview: "Vista previa de {name}",
  },
  filterPresets: {
    none: "Ninguno",
    retro: "Retro",
    vintage: "Vintage",
    wesAnderson: "Wes Anderson",
    noir: "Cine negro",
    polaroid: "Polaroid",
    cinematic: "Cinematográfico",
    cool: "Frío",
    warm: "Cálido",
    expired: "Película vencida",
    kodak: "Kodak",
    super8: "Super 8",
  },
  animation: {
    title: "Animaciones",
    enter: "Animación de entrada",
    exit: "Animación de salida",
  },
  animations: {
    none: "Ninguna",
    fade: "Desvanecer",
    slideRight: "Deslizar",
    scale: "Escalar",
    bounce: "Rebote",
    flipX: "Voltear",
    zoomBlur: "Zoom",
    slideUp: "Deslizar",
    snapRotate: "Giro rápido",
    glitch: "Glitch",
    swipeReveal: "Barrido",
    floatIn: "Flotar",
  },
  image: {
    preview: "Vista previa de la imagen",
  },
  video: {
    preview: "Vista previa del video",
    playbackSpeed: "Velocidad de reproducción",
    reset: "Restablecer",
    selectSpeed: "Elige la velocidad",
    speedNormal: "1x (normal)",
    speedCustom: "{speed}x (personalizada)",
  },
  pexels: {
    searchImages: "Buscar imágenes...",
    searchVideos: "Buscar videos...",
    orientation: "Orientación",
    allOrientations: "Todas las orientaciones",
    landscape: "Horizontal",
    portrait: "Vertical",
    square: "Cuadrado",
    size: "Tamaño",
    allSizes: "Todos los tamaños",
    small: "Pequeño",
    medium: "Mediano",
    large: "Grande",
    imagesFound: "{n} imágenes encontradas",
    videosFound: "{n} videos encontrados",
    page: "Página {n}",
    photoBy: "Foto de {name}",
    videoBy: "Video de {name}",
    unknown: "Desconocido",
    by: "por {name}",
    noImagesFor: "No se encontraron imágenes para \"{query}\"",
    noVideosFor: "No se encontraron videos para \"{query}\"",
    poweredBy: "Con tecnología de",
    fetchErrorTitle: "Error al cargar el contenido",
    fetchErrorBody: "No se pudo cargar el contenido de Pexels. Inténtalo de nuevo más tarde.",
  },
  emptyState: {
    noneAvailable: "No hay {items} disponibles",
    noResults: "No se encontraron {items}",
    noResultsIn: "No se encontraron {items} en {source}",
    tryAnother: "Prueba con otra búsqueda",
    useSearch: "Usa la búsqueda para encontrar {items}",
    enterTerm: "Escribe lo que buscas arriba",
    mediaTypes: {
      templates: "plantillas",
      videos: "videos",
      images: "imágenes",
    },
  },
  localMedia: {
    savedUploads: "Archivos subidos",
    upload: "Subir",
    uploadMedia: "Subir archivos",
    uploadFailed: "No se pudo subir el archivo. Inténtalo de nuevo.",
    unsupportedType: "Tipo de archivo no compatible",
    deleteMedia: "Eliminar archivo",
    all: "Todo",
    images: "Imágenes",
    videos: "Videos",
    audio: "Audio",
    loading: "Cargando archivos...",
    emptyTitle: "No hay archivos",
    emptyHint: "Sube tu primer archivo para empezar",
    addToTimeline: "Agregar a la línea de tiempo",
    fileTypes: {
      image: "imagen",
      video: "video",
      audio: "audio",
    },
  },
  sounds: {
    library: "Música de Clip-Short",
    moods: {
      suspense: "Suspenso",
      epic: "Épica",
      uplifting: "Motivadora",
      calm: "Tranquila",
      playful: "Divertida",
      emotional: "Emotiva",
      tech: "Tecnología",
      lofi: "Lo-fi",
      oriental: "Oriental",
      dramatic: "Dramática",
    },
    searchTab: "Efectos de sonido",
    featuredTab: "Música",
    searchPlaceholder: "Buscar efectos de sonido…",
    searching: "Buscando sonidos...",
    noResults: "No se encontraron sonidos",
    searchPrompt: "Busca un efecto de sonido",
    poweredBy: "Con tecnología de Freesound.org",
    results: "{n} resultados",
    addToTimeline: "Agregar a la línea de tiempo",
    loading: "Cargando...",
    loadMore: "Cargar más",
    soundsFrom: "Sonidos de",
    creativeCommons: "(Creative Commons)",
    musicHint: "Nuestra propia música, sin problemas para publicar en cualquier red. Elige un estilo, escucha sus pistas y pon una bajo todo tu video: suena suave bajo la voz. Cambia el volumen en la línea de tiempo.",
    putUnder: "Poner bajo el video",
    useInstead: "Usar esta",
    underVideo: "Bajo este video: {mood}",
    removeMusic: "Quitar",
    listen: "Escuchar {mood}",
  },
  progressBar: {
    description: "Se llena mientras el video avanza, para que quien lo ve sepa cuánto falta. Dura lo mismo que la capa en la línea de tiempo.",
    colour: "Color",
    colourSwatch: "Color {color}",
    position: "Posición",
    top: "arriba",
    bottom: "abajo",
    thickness: "Grosor",
    stretch: "Extender a todo el video",
    add: "Barra de progreso",
    replace: "Reemplazar la barra de progreso",
    addHint: "Muestra cuánto falta del video",
  },
};
